<template>
  <div class="w-full">
    <label
      v-if="label"
      class="mb-1.5 block text-sm font-medium text-primary"
    >
      {{ label }}
    </label>
    <textarea
      rows="6"
      :disabled="isDisabled"
      :placeholder="placeholder"
      class="text-md border-1 focus:shadow-outline block w-full rounded-sm border-gray-300 bg-white leading-tight text-primary placeholder-slate-300 shadow-sm focus:border-main-primary focus:ring-main-primary"
      :class="{
        'text-sm': sizeSm,
        'pointer-events-none cursor-not-allowed bg-zinc-300': disabled,
      }"
      :value="val"
      :required="required"
      @input="$emit('input', $event.target.value)"
    />
    <small
      v-if="errorMessage"
      class="mt-2 block text-red-primary"
    >{{
      errorMessage
    }}</small>
  </div>
</template>

<script>
export default {
  name: 'TextareaInput',

  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    val: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    sizeSm: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['input'],

  data() {
    return {
      errorMessage: this.error,
      isDisabled: this.disabled,
    }
  },

  watch: {
    error(newError) {
      this.errorMessage = newError
    },
    disabled(newDisabled) {
      this.isDisabled = newDisabled
    },
  },
}
</script>
